import React, { useEffect, useState, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AppRoutes from './Routes';
import './App.css';
import CookiesServices from './services/CookiesService';
import Sidebar from './layout/sidebar/SideBar';
import Header from './layout/header/Header';
import CircularProgress from '@mui/material/CircularProgress';
import './oneclick/configure/i18n';
import ReactGA from 'react-ga4';
import { Document, Page } from 'react-pdf';
import ImpersonationSelect from './pages/ImpersonationSelect/ImpersonationSelect';

const App = () => {
    const [isSidebarVisible, setSidebarVisible] = useState(true);
    const [impersonationUsers, setImpersonationUsers] = useState([]);
    const [showImpersonationPopup, setShowImpersonationPopup] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const cookieService = useMemo(() => new CookiesServices(), []);
    const navigate = useNavigate();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const module = params.get("code");
    const [isSecured, setIsSecured] = useState(true);
    const isPDPAForm =
        module === "pdpa-english" ||
        module === "pdpa-sinhala" ||
        module === "pdpa-tamil";
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
    const [showPdf, setShowPdf] = useState(false);

    var isPasswordResetPage = location.pathname === '/passwordReset';
    var isEProfilePage = location.pathname === '/eProfile';
    var isWelcome = location.pathname === '/qrpay';
    const isValidation = location.pathname === '/validation';
    const isPolicy = location.pathname === '/policy';
    const isOTPVerification = location.pathname === '/otp-verification';
    const isHelp = location.pathname === '/help';
    const isContact = location.pathname === '/contact';
    const isAbout = location.pathname === '/about';
    const isEpolicy = location.pathname === '/epolicy';
    const isHome = location.pathname === '/home';
    var isLogin = location.pathname === '/login';
    const isVerify = location.pathname === '/verify';
    const isViewOrDownload = location.pathname === '/viewOrDownload';
    const isDoc = location.pathname === '/doc';
    const isDownloadConfirmation = location.pathname === '/downloadConfirmation';
    const isEpolicyDetailed = location.pathname === '/epolicyDetailed';
    const isEpolicySummary = location.pathname === '/epolicySummary';
    const isBC = location.pathname.startsWith('/eProfile/');
    const isErrorPage = location.pathname === '/error';
    const isAgreementPage = location.pathname === '/agreement';
    const isActivityDetailed = location.pathname === '/activityDetailed';
    const isLeadDetailed = location.pathname === '/leadDetailed';

    const hideHeaderAndSidebar = isEpolicy || isHome || isLogin || isVerify || isViewOrDownload || isDoc || isDownloadConfirmation || isEpolicyDetailed || isEpolicySummary || isBC || isErrorPage || isAgreementPage || isPDPAForm || isActivityDetailed || isLeadDetailed;

    const [numPages, setNumPages] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);

    const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };
 
    ReactGA.send({ hitType: "pageview", page: location.pathname });

    useEffect(() => {
        if (window.self === window.top) {
            setIsSecured(true);
        } else {
            setIsSecured(false);
        }

        const authenticateUser = async () => {
            if (
                location.pathname === "/error" ||
                location.pathname === "/agreement" ||
                isPDPAForm
            ) {
                setIsLoggedIn(true);
                return;
            }
            const params = new URLSearchParams(window.location.search);
            const module = params.get('code');
            const agent = params.get('agent');
            const eprofileAgent = params.get('eprofile');
            const policyNumber = params.get('p');

            // Check if URL contains code=pdf => show pdf
            if (module === 'pdf') {
                // setShowPdf(true);
                // return;
                 return (
                        <div>
                            <Document file="https://ehubuat.lolclife.com/IL201400223500.pdf" onLoadSuccess={onDocumentLoadSuccess}>
                                <Page pageNumber={pageNumber} />
                            </Document>
                            <p>
                                Page {pageNumber} of {numPages}
                            </p>
                        </div>
                    );
            }

            // Redirect to login with policyNumber if `p` is present
            if (params.has("p")) {
                isLogin = true;
                navigate(`/login?p=${policyNumber}`);
                //return;
            }

            else if (module === "qrpay") {
                isWelcome = true;
                navigate('/qrpay');
            }

            else if (module === "passwordreset") {
                isPasswordResetPage = true;
                navigate('/passwordReset');
            }

            else if (module === "eprofile") {
                isPasswordResetPage = true;
                navigate('/eProfile');
            }

            else if (module === "renewals") {
                navigate('/renewals');  // ?code=renewals
            }
            else if (module === "newbusiness") {
                navigate('/newBusiness'); // ?code=newbusiness
            }
            else if (module === "policyDetails") {
                navigate('/policyDetails'); // ?code=policyDetails
            }
            else if (module === "olddashboard") {
                navigate('/oldDashboard'); // ?code=oldDashboard
            }
            else if (module === "newdashboard") {
                navigate('/newDashboard'); // ?code=oldDashboard
            }
            else if (module === "nationaldashboard"){
                navigate('/nationalDashboard'); // ?code=nationalDashboard
            }
            else if (module === "anbpleaderboard"){
                navigate('/anbpleaderboard'); // ?code=anbpleaderboard
            }
            else if (module === "incomeStatement"){
                navigate('/incomeStatement'); // ?code=incomeStatement
            }
            else if (module === "report"){
                navigate('/report'); // ?code=report
            }
            else if (module === "MDRTDashboard"){
                navigate('/MDRTDashboard'); // ?code=agentDashboard
            }
            else if (module === "MDRTLeaderboard"){
                navigate('/MDRTLeaderboard'); // ?code=leaderDashboard
            }
            else if (module === "ActivityDetailed"){
                navigate('/activityDetailed'); // ?code=activityDetailed
            }
            else if (module === "LeadDetailed"){
                navigate('/leadDetailed'); // ?code=leadDetailed
            }
            else if (module === "epolicy") {
                navigate('/login?code=epolicy');
                isLogin = true;
            }
            else if (eprofileAgent && eprofileAgent.startsWith("A0")) {
                await cookieService.saveLoginDetailsFromUrl();
                setIsLoggedIn(true);
                navigate(`/eProfile/${eprofileAgent}`, { replace: true });
                return;
            }

            const loginSuccess = await cookieService.saveLoginDetailsFromUrl();

            if (loginSuccess) {
                const impersonationList = cookieService.getImpersonationUsers() || [];

                if (Array.isArray(impersonationList) && impersonationList.length > 1) {
                    setImpersonationUsers(impersonationList);
                    setShowImpersonationPopup(true);
                    return;
                }

                setIsLoggedIn(true);

            } else if (Number(cookieService.get("errorCode")) === 2) {
                navigate("/error", { replace: true });
                return;

            } else if (Number(cookieService.get("errorCode")) === 3) {
                console.log("Redirecting to agreement page");
                navigate("/agreement", { replace: true });
                return;
            } else {
                if (isPasswordResetPage || isWelcome || isValidation || isPolicy || isOTPVerification || isHelp || isContact || isAbout || isLogin || isVerify || isEpolicy || isHome || isBC) {
                    setIsLoggedIn(true);
                } else {
                    window.location.href = `${process.env.REACT_APP_LOGIN_URL}`;
                }
            }
        };

        authenticateUser();
    }, [cookieService, navigate, location.pathname]);

    useEffect(() => {
        if (!localStorage.getItem('sidebarFirstLoad')) {
            localStorage.setItem('sidebarFirstLoad', 'true');
            if (window.innerWidth <= 768) {
                setSidebarVisible(false); // <-- Hide sidebar on first load for small screens
            }
        }
    }, []);

    useEffect(() => {
        const handleResize = () => {
            const isNowSmall = window.innerWidth <= 768;
            setIsSmallScreen(isNowSmall);
            // Only toggle sidebar visibility on resize after first load
            if (localStorage.getItem('sidebarFirstLoad')) {
                setSidebarVisible(!isNowSmall);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    if (!isSecured) {
        return <div className='security-msg'>If you see this page, Web App link you have clicked on is under Clickjacking security attack!</div>;
    }

    if (showPdf) {
        return (
            <div style={{ width: '100vw', height: '100vh' }}>
                <iframe
                    title="pdf"
                    src="/IL201400223500.pdf"
                    style={{ width: '100%', height: '100%', border: 'none' }}
                />
            </div>
        )
    }


    return (
        <div className="app">
            {showImpersonationPopup && (
                <ImpersonationSelect users={impersonationUsers} />
            )}
            {!isLoggedIn && !showImpersonationPopup && !impersonationUsers.length ? (
                <div className="loading-overlay">
                    <CircularProgress
                        size={60}
                        thickness={4.5}
                        sx={{
                            color: 'linear-gradient(to right, red, blue)',
                        }}
                    />
                </div>
            ) : (
                <>
                    {(isPasswordResetPage || (!isWelcome && !isValidation && !isPolicy && !isOTPVerification && !isHelp && !isContact && !isAbout && !hideHeaderAndSidebar && !isLogin)) && (
                        <div className="content-wrapper">
                            {!isPasswordResetPage && !hideHeaderAndSidebar && isSidebarVisible && (
                                <Sidebar onToggleSidebar={() => setSidebarVisible(!isSidebarVisible)} />
                            )}
                            <div className={`main-content ${!hideHeaderAndSidebar && isSidebarVisible ? 'with-sidebar' : 'full-width'}`}>
                                {!isPasswordResetPage && !hideHeaderAndSidebar && (
                                    <Header
                                        onToggleSidebar={() => setSidebarVisible(!isSidebarVisible)}
                                        currentPath={location.pathname}
                                    />
                                )}
                                {!showImpersonationPopup && (
                                    <AppRoutes isLoggedIn={isLoggedIn} />
                                )}
                            </div>
                        </div>
                    )}
                    {(isWelcome || isValidation || isPolicy || isOTPVerification || isHelp || isContact || isAbout || hideHeaderAndSidebar || isLogin) && (
                        <main className="app-content">
                            <div className="content-inner">
                                {!showImpersonationPopup && (
                                    <AppRoutes isLoggedIn={isLoggedIn} />
        )}
                            </div>
                        </main>
                    )}
                </>
            )}
        </div>
    );
    
};
 
export default App;
